import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50 py-12 md:py-16">
      <div className="px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <h3 className="font-heading text-2xl md:text-4xl font-bold">ITAOBUY</h3>
            <p className="mt-4 text-background-50/70 text-sm leading-relaxed max-w-xs">
              Il punto di riferimento italiano per Itaobuy Spreadsheet. Guide, analisi e consigli per ottimizzare la tua esperienza.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-8 h-8 rounded-full border border-background-50/30 flex items-center justify-center cursor-pointer hover:bg-background-50/10 transition-colors">
                <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 rounded-full border border-background-50/30 flex items-center justify-center cursor-pointer hover:bg-background-50/10 transition-colors">
                <i className="ri-instagram-line w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 rounded-full border border-background-50/30 flex items-center justify-center cursor-pointer hover:bg-background-50/10 transition-colors">
                <i className="ri-facebook-line w-4 h-4 flex items-center justify-center"></i>
              </span>
              <span className="w-8 h-8 rounded-full border border-background-50/30 flex items-center justify-center cursor-pointer hover:bg-background-50/10 transition-colors">
                <i className="ri-youtube-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </div>

          <div>
            <p className="text-xs tracking-widest uppercase text-background-50/50 font-semibold mb-4">INDIRIZZO</p>
            <p className="text-background-50/70 text-sm leading-relaxed">
              Itaobuy Spreadsheet Italia
              <br />
              Via delle Guide Digitali, 42
              <br />
              20100 Milano, Italia
            </p>
            <p className="text-xs tracking-widest uppercase text-background-50/50 font-semibold mt-6 mb-3">TELEFONO</p>
            <p className="text-background-50/70 text-sm">+39 02 1234 5678</p>
            <p className="text-xs tracking-widest uppercase text-background-50/50 font-semibold mt-6 mb-3">EMAIL</p>
            <p className="text-background-50/70 text-sm">info@itaobuyspread.lat</p>
          </div>

          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lifestyle%20editorial%20photograph%20on%20soft%20textured%20cream%20background%2C%20single%20stylish%20accessory%20displayed%20artistically%2C%20warm%20natural%20lighting%2C%20clean%20sophisticated%20aesthetic%2C%20olive%20green%20and%20sand%20tones%2C%20European%20style%2C%20vertical%20composition%20with%20generous%20negative%20space&width=400&height=500&seq=footer-img-v2-01&orientation=portrait&nocache=true"
              alt="Itaobuy Italia"
              className="w-full max-w-[200px] rounded-lg object-cover ml-auto"
            />
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs">
            &copy; 2026 Itaobuyspread.lat. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/articolo-itaobuy-spreadsheet-guida"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              Guida
            </Link>
            <Link
              to="/articolo-sicurezza-itaobuy-spreadsheet"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sicurezza
            </Link>
            <Link
              to="/"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}